import React from 'react';
import { noop } from 'lodash';

import PageHeader, { PageBackground } from '@domain/page-header';
import MveFeature from '@features/mve';
import { useElearningWpOnSiteMveNumber } from '@services/elearning-wp-onsite';
function ElearningWpOnSiteMvePage() {
  const { mutateAsync, isPending } = useElearningWpOnSiteMveNumber();

  const onSubmit = async ({ mveNumber }: { mveNumber: string }) => {
    await mutateAsync({ mveNumber }).catch(noop);
  };

  return (
    <PageBackground>
      <PageHeader />
      <MveFeature onSubmit={onSubmit} isPending={isPending} />
    </PageBackground>
  );
}

export default ElearningWpOnSiteMvePage;
